var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column", attrs: { id: "errorReport" } },
    [
      _c(
        "md-field",
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("message.writeFeedback")))]),
          _vm._v(" "),
          _c("md-textarea", {
            model: {
              value: _vm.errorMsg,
              callback: function ($$v) {
                _vm.errorMsg = $$v
              },
              expression: "errorMsg",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-button",
        {
          staticClass: "align-self-end md-raised md-primary",
          staticStyle: { "min-width": "160px" },
          attrs: { disabled: _vm.isSending },
          on: { click: _vm.handleSendErrorMsg },
        },
        [
          _vm.isSending
            ? _c("md-progress-spinner", {
                staticClass: "md-accent text-light",
                attrs: { "md-diameter": 30, "md-mode": "indeterminate" },
              })
            : _c("span", [_vm._v(_vm._s(_vm.$t("message.sendFeedback")))]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }